import React, { useState } from 'react';
import axios from 'axios';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Alert } from 'react-bootstrap';


function Motdepasse(props) {
  const [error, setError] = useState(null);
  const [changement, setChangement] = useState(false);
  const [success, setSucces] = useState(false);
  const [mdp, setMdp] = useState('');
  const [new_mdp, setNew_mdp] = useState('');
  const [confirm_mdp, setConfirm_mdp] = useState('');
  const [isLoading,setIsLoading] = useState(false)
  const apiUrl = process.env.REACT_APP_API_URL;


  const handleSubmit = async (e) => {
    e.preventDefault();
    setChangement(false);
    setError(null);
    setIsLoading(true)
    setSucces(false)


    if (!mdp || !new_mdp || !confirm_mdp) {
      setError("Tous les champs requis ne sont pas remplis.");
      setIsLoading(false)
      return;
    }

    try {
      await axios.patch(`${apiUrl}/parametre/modification/mot-de-passe`, {
        type: props.userData.user.type,
        id: props.userData.user.donnée.results[0].id,
        mdp: mdp,
        new_mdp: new_mdp,
        confirm_mdp: confirm_mdp
      }, {
        withCredentials: true
      });

      setError(null);
      setSucces(true);
      setNew_mdp('')
      setMdp('')
      setConfirm_mdp('')
      setIsLoading(false)
      setTimeout(() => {
        setSucces(false);
      }, 20000);
    } catch (error) {
      if (error.response) {
        setIsLoading(false)
        setError(error.response.data.message);
      } else {
        setIsLoading(false)
        setError(true);
      }
    }
  };

  return (
    <>
        {isLoading && (
    <>
      <div className="centered-content">
            <img src="/img/logo.png" alt="Logo" className="centered-logo" />
            <br/>
            <span className="loader"></span>
      </div>
    </>

  )}
      {props.userData ? (
        <>
              {changement && (
        <Modal show={changement} onHide={() => setChangement(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Modification du mot de passe</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <>Êtes-vous sûr de modifier votre mot de passe ?</>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setChangement(false)}>
              Annuler
            </Button>
            <Button variant="primary" onClick={(e) => {handleSubmit(e)}} style={{backgroundColor:"#00E676", borderColor:'#00E676'}}>
              Modifier
            </Button>
          </Modal.Footer>
        </Modal>
      )}

                <h2 style={{ textAlign: "center" }}>Modifier votre mot de passe</h2>
                {error && (
                <Alert key="danger" variant="danger" style={{fontSize:"15px", margin:"auto", width : "80%"}}>
                    Erreur ! {error}. 
                </Alert>
                )}
                {success && (
                        <Alert key="success" variant="success" style={{fontSize:"15px", margin:"auto", width : "80%"}}>
                        Félicitations ! Votre mot de passe à était modifié avec succés.
                      </Alert>
              )}
                <div className="card-body">
                <div className="ajout2">
                  <form className="Invite_Joueur" onSubmit={(e) => { e.preventDefault(); setChangement(true); }}>
                    <div>
                      <label htmlFor="mdp_actuel" className="label-1">
                        <br />Mot de passe actuel<br />
                        <input
                          name="mdp_actuel"
                          type="password"
                          required
                          id="mdp_actuel"
                          value={mdp}
                          onChange={(e) => setMdp(e.target.value)}
                        />
                      </label>
                    </div>
                    <div>
                      <label htmlFor="new_mdp" className="label-1">
                        <br />Nouveau mot de passe<br />
                        <input
                          name="new_mdp"
                          type="password"
                          required
                          id="new_mdp"
                          value={new_mdp}
                          onChange={(e) => setNew_mdp(e.target.value)}
                        />
                        <br/><span style={{ fontSize: '10px' }} >Avec au moins 12 caractères, 1 caractère spécial et 1 chiffre.</span>
                      </label>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      <label htmlFor="new_mdp_confirm" className="label-1">
                        <br />Confirmer le mot de passe<br />
                        <input
                          name="new_mdp_confirm"
                          required
                          type="password"
                          id="new_mdp_confirm"
                          value={confirm_mdp}
                          onChange={(e) => setConfirm_mdp(e.target.value)}
                        />
                        <br/><span>&nbsp;</span>
                      </label>
                    </div>
                    <div>
                      <br />
                      <button type="submit" className="conect" style={{ margin: "auto" }}>
                        Modifier votre mot de passe
                      </button>
                    </div>
                  </form>
                </div>
                </div>
                
        </>
      ) : (
        <>
          <div id="alert-message" className="alert">
            <strong>Erreur ! </strong>{error} <span id="alert-text"></span>
          </div>
        </>
      )}
    </>
  );
}

export default Motdepasse;
